import type { FC } from 'react';

import { selectKeyframesByVersionIdMap } from '@iconik-io/shared-lib/src/redux/entities/selectors/keyframes';
import type { AssetsAssetVersionSchemaWithIdExtended } from '@iconik-io/shared-lib/src/redux/entities/selectors/versions';
import { findBestKeyframe } from '@iconik-io/shared-lib/src/utils/find_best_keyframe';
import { CheckboxField } from '@iconik-io/uad';

import { selectDateTimeFormat } from '../../ducks/settings/select_date_time_format';
import { useAppSelector } from '../../store/react_redux_typed';
import { formatDate } from '../input_date/utils';
import Label from '../label/label';

import styles from './version_selector.module.css';

const VersionSelectorVersionItem: FC<{
  versionItem: AssetsAssetVersionSchemaWithIdExtended;
  latestVersionId: undefined | string;
  assetId: string;
  onSetSelectedVersion: (value: boolean) => void;
  isSelected: boolean;
}> = ({
  versionItem,
  latestVersionId,
  assetId,
  onSetSelectedVersion,
  isSelected,
}) => {
  const keyframeByVersionId = useAppSelector((state) =>
    selectKeyframesByVersionIdMap(state, assetId),
  );
  const dateTimeFormat = useAppSelector(selectDateTimeFormat);

  const thumbnailUrl = versionItem.id
    ? (findBestKeyframe(keyframeByVersionId[versionItem.id])?.url ?? undefined)
    : undefined;

  return (
    <div className={styles.version_item}>
      <CheckboxField isSelected={isSelected} onChange={onSetSelectedVersion} />

      <div
        className={styles.version_thumbnail}
        style={{
          backgroundImage: `url(${thumbnailUrl})`,
        }}
      />
      <Label variant="gray">{versionItem.name}</Label>
      {versionItem.date_created ? (
        <span>{formatDate(versionItem.date_created, dateTimeFormat)}</span>
      ) : null}
      {latestVersionId && latestVersionId === versionItem.id ? (
        <Label className={styles.label} variant="success">
          Latest
        </Label>
      ) : null}
    </div>
  );
};

export default VersionSelectorVersionItem;
